import {
  dataSearch,
  isMounted,
  pagingSearch,
} from '../../helpers/getter-commons';

// Self
export const getSelfInfo = (state) => dataSearch(state.admins.self.data);
export const isSelfInfoFetching = (state) => state.admins.self.isFetching;

// all admins
export const getAdmins = (state) =>
  dataSearch(state.admins.list.data, {
    list: true,
  });
export const isAdminsFetching = (state) => state.admins.list.isFetching;
export const isAdminMounted = (state) => isMounted(state.admins.list.data);
export const getAdminsPaging = (state) => pagingSearch(state.admins.list.data);

// by id
export const getAdmin = (state) => dataSearch(state.admins.selected.data);
export const isAdminByIdFetching = (state) => state.admins.selected.isFetching;
export const isAdminByIdMounted = (state) =>
  isMounted(state.admins.selected.data);
